export const styles = [{
		"featureType": "all",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#dad9d6"
			},
			{
				"gamma": "10.00"
			},
			{
				"saturation": "0"
			},
			{
				"lightness": "0"
			},
			{
				"weight": "1"
			}
		]
	},
	{
		"featureType": "administrative.province",
		"elementType": "geometry",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#000000"
			}
		]
	},
	{
		"featureType": "landscape",
		"elementType": "all",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "landscape.natural",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#ebebeb"
			}
		]
	},
	{
		"featureType": "landscape.natural.terrain",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#e5e5e5"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "all",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "poi.attraction",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#e2e1e1"
			}
		]
	},
	{
		"featureType": "poi.business",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#e2e1e1"
			}
		]
	},
	{
		"featureType": "poi.government",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#e2e1e1"
			}
		]
	},
	{
		"featureType": "poi.medical",
		"elementType": "geometry.fill",
		"stylers": [{
				"color": "#e2e1e1"
			},
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "poi.park",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#9ed6c1"
			},
			{
				"saturation": "0"
			},
			{
				"weight": "1"
			},
			{
				"lightness": "48"
			}
		]
	},
	{
		"featureType": "poi.place_of_worship",
		"elementType": "geometry.fill",
		"stylers": [{
				"color": "#e2e1e1"
			},
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "poi.school",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#e2e1e1"
			}
		]
	},
	{
		"featureType": "poi.sports_complex",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#e2e1e1"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "all",
		"stylers": [{
				"saturation": -100
			},
			{
				"lightness": 45
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "all",
		"stylers": [{
			"visibility": "simplified"
		}]
	},
	{
		"featureType": "road.highway.controlled_access",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"saturation": "100"
			},
			{
				"color": "#fcbbd7"
			}
		]
	},
	{
		"featureType": "road.highway.controlled_access",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "road.arterial",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		}]
	},
	{
		"featureType": "road.local",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "geometry.fill",
		"stylers": [{
				"visibility": "on"
			},
			{
				"color": "#ffffff"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#fbb6b6"
		}]
	},
	{
		"featureType": "transit",
		"elementType": "labels.icon",
		"stylers": [{
			"color": "#fbb6b6"
		}]
	},
	{
		"featureType": "transit.station.bus",
		"elementType": "geometry.fill",
		"stylers": [{
			"saturation": "100"
		}]
	},
	{
		"featureType": "water",
		"elementType": "all",
		"stylers": [{
				"color": "#568ea5"
			},
			{
				"visibility": "on"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "geometry.fill",
		"stylers": [{
			"color": "#99dcf5"
		}]
	},
	{
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [{
				"color": "#2baedf"
			},
			{
				"visibility": "on"
			}
		]
	}
]

const markerColors = {
	butcher: {
		bg: '#deb817',
		color: '#000000',
	},
	kitchenrepublic: {
		bg: '#e0b150',
		color: '#ffffff',
	},
	missmiu: {
		bg: '#ff947f',
		color: '#ffffff',
	},
	negishi: {
		bg: '#e23810',
		color: '#ffffff',
	},
	nooch: {
		bg: '#e23810',
		color: '#ffffff',
	},
	outbacklodge: {
		bg: '#c31b1d',
		color: '#ffffff',
	},
	fwgch: {
		bg: '#9ed6c1',
		color: '#403c3a',
	},
}

export function getMarkerIcon(theme) {
	return {
		url: `data:image/svg+xml;base64,${markerIcon(markerColors[theme]?.bg || 'black')}`,
		size: new google.maps.Size(40, 54),
		origin: new google.maps.Point(0, 0),
		labelOrigin: new google.maps.Point(20, 20),
		anchor: new google.maps.Point(20, 54),
		scaledSize: new google.maps.Size(40, 54),
	}
}

export function getGeoIcon(theme) {
	return {
		url: `data:image/svg+xml;base64,${geoIcon(markerColors[theme]?.bg || 'black')}`,
		size: new google.maps.Size(48, 48),
		origin: new google.maps.Point(0, 0),
		labelOrigin: new google.maps.Point(24, 24),
		anchor: new google.maps.Point(24, 24),
		scaledSize: new google.maps.Size(48, 48),
	}
}

export function getMarkerLabel(theme) {
	return {
		color: markerColors[theme]?.color || 'white',
		fontSize: "15px",
		fontWeight: 'normal',
	}
}

function markerIcon(color = 'white') {
	return window.btoa(`
<svg width="40" height="55" viewBox="0 0 40 55" fill="${color}" xmlns="http://www.w3.org/2000/svg">
<path d="M20.0042 54.0029C21.9067 52.1311 32.233 38.9738 37.5755 29.0432L37.583 29.0288C37.5896 29.016 37.5961 29.0031 37.6041 28.9913C37.6132 28.9733 37.6231 28.9554 37.633 28.9378C37.6412 28.9231 37.6493 28.9085 37.6569 28.8939L37.6561 28.8914H37.6511C39.08 26.2564 39.879 23.3362 39.9873 20.3524C40.0956 17.3686 39.5104 14.3999 38.2761 11.6716C37.0418 8.94325 35.1909 6.52715 32.864 4.60673C30.5371 2.68641 27.7953 1.3122 24.8469 0.588656C21.8986 -0.134886 18.8211 -0.188832 15.8484 0.430944C12.8756 1.05062 10.0857 2.32781 7.69051 4.1654C5.29533 6.00309 3.35789 8.35277 2.02532 11.0361C0.692754 13.7194 0.000115248 16.6657 0 19.6515C0 19.6672 0 19.6828 0 19.6985C0.00391842 22.9052 0.810793 26.0621 2.34978 28.8906H2.34475L2.36495 28.9274C2.37601 28.9473 2.38729 28.9676 2.39761 28.9879C2.40769 29.0045 2.41692 29.0218 2.42615 29.0399C7.76951 38.9714 18.0958 52.1278 19.9991 54.0029H20.0042Z"/>
</svg>`)
}

function geoIcon(color = 'white') {
	return window.btoa(`
<svg width="40" height="40" viewBox="0 0 40 40" fill="${color}" xmlns="http://www.w3.org/2000/svg">
<circle cx="20" cy="20" r="20" fill-opacity="0.1"/>
<circle cx="20" cy="20" r="15" fill-opacity="0.2"/>
<circle cx="20" cy="20" r="10" fill-opacity="0.4"/>
<circle cx="20" cy="20" r="5"/>
</svg>
`)
}
